import Request from '../Request';
import { app } from '../../app';
/**
 * Base class for making requests
 */
var Repository = /** @class */ (function () {
    /**
     * Creates a new repository
     *
     * @param {string} baseUrl - The baseUrl that the repository will use to retrieve the resource
     */
    function Repository(baseUrl) {
        this.baseUrl = baseUrl;
        this.responseUnwrapper = app().unwrapStrategy;
    }
    /**
     * Sets the abortController
     *
     * @param abortController
     */
    Repository.prototype.setAbortController = function (abortController) {
        this.abortController = abortController;
        return this;
    };
    /**
     * Executes an HTTP request
     *
     * @param {string} url - The url to make the request to
     *
     * @param {RequestMethod} method - The request method
     *
     * @param {RequestDataType} data - Optional, data to be send with the request
     *
     * @return {Promise}
     */
    Repository.prototype.request = function (url, method, data) {
        return this.requestWithOptions(url, method, { data: data });
    };
    /**
     * Executes an HTTP request with axios request options
     *
     * @param {string} url - The url to make the request to
     *
     * @param {RequestMethod} method - The request method
     *
     * @param {AxiosRequestConfig} config - Optional, data to be send with the request
     *
     * @return {Promise}
     */
    Repository.prototype.requestWithOptions = function (url, method, config) {
        return new Request({ url: url, method: method, axiosConfig: config, unwrapper: this.responseUnwrapper }, this.abortController);
    };
    /**
     * Creates a url with the base url of the repo at front
     *
     * @param {string} url
     *
     * @return {string}
     */
    Repository.prototype.url = function (url) {
        if (url === void 0) { url = ''; }
        return this.baseUrl + url;
    };
    return Repository;
}());
export default Repository;
